(function(){
  document.documentElement.classList.add('js');
  var $=function(s,c){return (c||document).querySelector(s)},$$=function(s,c){return Array.prototype.slice.call((c||document).querySelectorAll(s))};

  // Lightweight event tracking: Microsoft Clarity custom events and a dataLayer push (GA4/GTM) when present
  var track=function(n){try{if(typeof window.clarity==='function')window.clarity('event',n);}catch(e){}
    try{(window.dataLayer=window.dataLayer||[]).push({event:'own_'+n});}catch(e){}};
  document.addEventListener('click',function(e){
    var a=e.target.closest&&e.target.closest('a,button,summary');if(!a)return;
    var t=a.getAttribute('data-track');if(t){track(t);return;}
    if(a.matches('a.btn[href="#founding"],a.hlink[href="#founding"]')){var sec=a.closest('section');track('cta_'+(sec&&sec.id?sec.id:'page'));}
    else if(a.matches('summary')&&a.parentNode.classList.contains('hwa')){track('whatsapp_open');}
    else if(a.matches('a.hlink[href="#inside"]')){track('link_inside');}
  });
  // Menu
  var mb=$('#menuBtn'),mp=$('#menuPanel');
  if(mb&&mp){
    mb.addEventListener('click',function(){var o=mb.getAttribute('aria-expanded')==='true';mb.setAttribute('aria-expanded',!o);mp.hidden=o;});
    $$('a',mp).forEach(function(a){a.addEventListener('click',function(){mb.setAttribute('aria-expanded','false');mp.hidden=true;});});
  }

  // Policy modals (footer): open text in place; links still work without JS
  $$('[data-policy]').forEach(function(a){a.addEventListener('click',function(e){
    var d=document.getElementById('policy-'+a.getAttribute('data-policy'));
    if(d&&d.showModal){e.preventDefault();d.showModal();}
  });});
  $$('.pmodal').forEach(function(d){d.addEventListener('click',function(e){
    if(e.target===d||(e.target.hasAttribute&&e.target.hasAttribute('data-close')))d.close();
  });});

  // Reveal on scroll
  if('IntersectionObserver' in window){
    var io=new IntersectionObserver(function(es){es.forEach(function(e){if(e.isIntersecting){e.target.classList.add('in');io.unobserve(e.target);}});},{threshold:.12});
    $$('.rv').forEach(function(el){io.observe(el);});
  } else {$$('.rv').forEach(function(el){el.classList.add('in');});}

  // Sticky CTA: show after hero, hide while the club section is on screen
  var sc=$('#stickyCta'),club=$('#founding'),hero=$('.hero');
  if(sc){
    var hHidden=false,cHidden=false,upd=function(){sc.classList.toggle('show',hHidden&&!cHidden);sc.setAttribute('aria-hidden',!(hHidden&&!cHidden));};
    if('IntersectionObserver' in window){
      if(hero)new IntersectionObserver(function(e){hHidden=!e[0].isIntersecting;upd();},{threshold:0,rootMargin:'-160px 0px 0px 0px'}).observe(hero);else{hHidden=true;upd();}
      if(club)new IntersectionObserver(function(e){cHidden=e[0].isIntersecting;upd();},{threshold:.15}).observe(club);
    } else {sc.classList.add('show');}
  }

  // Countdown (IST)
  var cd=$('[data-countdown]');
  if(cd){
    var t=new Date(cd.getAttribute('data-countdown')+':00+05:30').getTime();
    var n={d:$('[data-d]',cd),h:$('[data-h]',cd),m:$('[data-m]',cd),s:$('[data-s]',cd)};
    var tick=function(){var x=Math.max(0,t-Date.now()),p=function(v){return String(v).padStart(2,'0')};
      n.d.textContent=p(Math.floor(x/864e5));n.h.textContent=p(Math.floor(x%864e5/36e5));n.m.textContent=p(Math.floor(x%36e5/6e4));n.s.textContent=p(Math.floor(x%6e4/1e3));};
    if(!isNaN(t)){var done=$('.cd__done');var tick2=function(){if(t<=Date.now()){cd.hidden=true;if(done)done.hidden=false;return false;}tick();return true;};if(tick2()){var iv=setInterval(function(){if(!tick2())clearInterval(iv);},1000);}}else{cd.hidden=true;}
  }

  // Moment tabs (morning / afternoon / evening)
  var mt=$$('.mtab'),mpn=$$('.mpanel');
  var pick=function(k,f){mt.forEach(function(t,j){var on=j===k;t.setAttribute('aria-selected',on);t.tabIndex=on?0:-1;});
    mpn.forEach(function(p,j){p.classList.toggle('on',j===k);});if(f)mt[k].focus();};
  mt.forEach(function(t,k){
    t.addEventListener('click',function(){pick(k);track('moment_tab_'+['morning','afternoon','evening'][k]);});
    t.addEventListener('keydown',function(e){var n=e.key==='ArrowRight'?(k+1)%mt.length:e.key==='ArrowLeft'?(k+mt.length-1)%mt.length:-1;if(n>-1){e.preventDefault();pick(n,true);}});
  });
  // Open the tab that matches the time of day (IST-agnostic: uses the visitor's clock)
  if(mt.length===3){var hr=new Date().getHours();pick(hr>=5&&hr<13?0:hr>=13&&hr<19?1:(hr>=19||hr<5)?2:0);}

  $$('.js-founding').forEach(function(ff){ff.addEventListener('submit',function(e){if(!e.defaultPrevented)track('signup_submit_'+(ff.getAttribute('data-src')||'form'));});});
  if($('[data-posted]')||/customer_posted=true/.test(location.search)){track('signup_complete');}

  // 90-day journey
  var r=$('#dayRange');
  if(r){
    var stages=JSON.parse($('#stageData').textContent),dots=$('#dots'),i;
    for(i=0;i<90;i++){dots.appendChild(document.createElement('i'));}
    var sb=$$('.stages button');
    var set=function(v){
      v=+v;$('#dayNum').textContent=v;
      $$('i',dots).forEach(function(d,k){d.classList.toggle('on',k<v);});
      var s=stages.filter(function(x){return v>=x.from&&v<=x.to})[0]||stages[0];
      $('#stageTitle').textContent=s.title;$('#stageText').textContent=s.text;
      $('#stageList').innerHTML=s.list.map(function(l){return '<li>'+l+'</li>'}).join('');
      sb.forEach(function(b,k){b.classList.toggle('on',stages[k]===s);});
      r.setAttribute('aria-valuetext','Day '+v+': '+s.title);
    };
    r.addEventListener('input',function(){set(r.value);});
    sb.forEach(function(b,k){b.addEventListener('click',function(){r.value=stages[k].from;set(r.value);});});
    set(r.value);
  }

  // Founding sign-ups (top box + club form): consent tags, phone check, opted-in state
  var KEY='own_optin';
  var norm=function(v){var d=(v||'').replace(/\D/g,'');if(d.length>10&&d.indexOf('91')===0)d=d.slice(2);if(d.length===11&&d.charAt(0)==='0')d=d.slice(1);return d;};
  $$('.js-founding').forEach(function(ff){ff.addEventListener('submit',function(e){
    var err=$('.js-err',ff),wa=$('.js-wa',ff),wc=$('.js-wac',ff);
    var fail=function(m){var hw=$('.hwa',ff);if(hw)hw.open=true;if(err){err.textContent=m;err.hidden=false;err.scrollIntoView({block:'center'});}e.preventDefault();};
    if(err)err.hidden=true;
    var num=wa?norm(wa.value):'',useWa=!!(wc&&wc.checked);
    if(num&&!useWa)return fail('Please tick the WhatsApp box if you want us to use your number.');
    if(useWa&&!/^[6-9]\d{9}$/.test(num))return fail('Please enter a valid 10-digit Indian mobile number.');
    var tags=['founding-club','email-optin'];
    if(useWa)tags.push('whatsapp-optin','wa-91'+num);
    if(ff.getAttribute('data-src'))tags.push('src-'+ff.getAttribute('data-src'));
    var tf=$('input[name="contact[tags]"]',ff);if(tf)tf.value=tags.join(',');
    var fn=$('input[name="contact[first_name]"]',ff);
    try{sessionStorage.setItem('own_pending',JSON.stringify({wa:useWa,name:fn&&fn.value?fn.value.trim().split(' ')[0]:''}));}catch(x){}
  });});
  var justPosted=/customer_posted=true/.test(location.search)||!!$('[data-posted]');
  if(justPosted){try{
    var raw=sessionStorage.getItem('own_pending');
    if(raw){var pd=JSON.parse(raw);localStorage.setItem(KEY,pd.wa?'wa':'email');if(pd.name)localStorage.setItem('own_name',pd.name);sessionStorage.removeItem('own_pending');}
    else if(!localStorage.getItem(KEY)){localStorage.setItem(KEY,'email');}
  }catch(x){}}
  var st=null,nm='';try{st=localStorage.getItem(KEY);nm=localStorage.getItem('own_name')||'';}catch(x){}
  if(st){var root=document.documentElement;root.classList.add('optedin');root.setAttribute('data-optin',st);
    $$('.js-name').forEach(function(s){if(nm)s.textContent=', '+nm.replace(/[<>&"]/g,'');});}
  $$('[data-reset]').forEach(function(b){b.addEventListener('click',function(){
    try{localStorage.removeItem(KEY);localStorage.removeItem('own_name');}catch(x){}
    history.replaceState(null,'',location.pathname+'#founding');location.reload();});});
  var cf=$('#thanksConfetti');
  if(st&&justPosted){
    if(cf){var cc=['#FF6A13','#1769E0','#7A3BC4','#fff','#FFD23F'];for(var k=0;k<46;k++){var el=document.createElement('i');el.style.setProperty('--x',Math.random()*100);el.style.setProperty('--d',Math.random()*1.2);el.style.setProperty('--c',cc[k%cc.length]);cf.appendChild(el);}}
    var target=(location.hash==='#foundingForm')?$('#clubThanks'):$('.hero-thanks');
    if(target)setTimeout(function(){target.scrollIntoView({behavior:'smooth',block:'center'});},250);
  }
})();
